<template>
    <v-app
        id="inspire"
        v-if="isAuthenticated && hasAzureObjectId"
    >
        <!--Sidebar-->
        <v-navigation-drawer
            :value="drawerLeft"
            app
                color="primary"
                dark
            disable-resize-watcher
            fixed
        >

            <TheSidebarMenu />
        </v-navigation-drawer>

        <v-navigation-drawer
            :value="drawerRight"
            @input="drawerStateChanged"
            app
            disable-resize-watcher
            fixed
            right
            temporary
        >
            <TheRighthandSidebarMenu />
        </v-navigation-drawer>
        <!--Top Nav Bar-->
        <TheToolbar />
        <!-- Main Content -->
        <v-content>
            <v-container
                fill-height
                fluid
                pl-3
                pr-3
                pt-0
            >
                <v-layout>
                    <v-flex text-xs-center>
                        <router-view />
                        <TheSnackbar />
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <TheFooter />
    </v-app>
    <v-app
        id="loginContainer"
        v-else
    >
        <Login />
        <TheFooter />
    </v-app>
</template>

<script>
import TheFooter from '@/components/TheFooter.vue';
import TheSidebarMenu from '@/components/TheSidebarMenu.vue'; // @ is an alias to /src
import TheSnackbar from '@/components/TheSnackbar.vue';
import TheToolbar from '@/components/TheToolbar.vue';
import { UPDATE_USER_PERMISSION } from "@/store/person/mutations";
import { UPDATE_USER_INFO } from "@/store/user/actions";
import Login from '@/views/Login.vue';
import { mapGetters } from "vuex";
import authentication from './authentication';
import TheRighthandSidebarMenu from "./components/TheRighthandSidebarMenu";
import { CLOSE_RIGHT_DRAWER, TOGGLE_LEFT_DRAWER, TOGGLE_RIGHT_DRAWER } from "./store/this_app/mutations";

    export default {
        name: "App",

        components: {
            TheSidebarMenu,
            TheRighthandSidebarMenu,
            TheToolbar,
            TheSnackbar,
            TheFooter,
            Login
        },

        computed: {
            isAuthenticated() {
                return this.getUserProfile();
            },
            hasAzureObjectId() {
                if (this.userProfile.azureAdObjectId) {
                    return true;
                }
                return false;
            },
            ...mapGetters(
            ["userProfile", "permissionTypes", "userPermissions"]
            ),
            userPermissionType: {
                get() {
                    return this.$store.state.permission.userPermissionType;
                },
                set(value) {
                    this.$store.commit(UPDATE_USER_PERMISSION, value);
                }
            },
            ...mapGetters(
            [
                "drawerLeft",
                "drawerRight",
            ]
            )
        },

        created() {
            if (this.getUserProfile()) {
                if (this.userProfile.name == false) {
                    this.addUserProfileToStore();
                }
            }
            // this.getPermissions();

            // console.log(process.env.VUE_APP_HOME_URL);
        },

        methods: {
            drawerStateChanged(event) {
                if (!event) {
                    this.$store.commit(TOGGLE_RIGHT_DRAWER);
                }
            },
            toggleLeftDrawer() {
                this.$store.commit(TOGGLE_LEFT_DRAWER);
            },
            toggleRightDrawer() {
                this.$store.commit(TOGGLE_RIGHT_DRAWER);
            },
            closeDrawerRight() {
                this.$store.commit(CLOSE_RIGHT_DRAWER);
            },
            logIn() {
                authentication.signIn();
            },
            getUserProfile() {
                return authentication.getUserProfile();
            },
            addUserProfileToStore() {
                authentication.acquireToken({
                    scopes: authentication.loginRequest
                    //scopes: ['api://31cd524c-79e5-430a-9aff-631349cd5b2b/access_as_user', 'User.Read']
                }).then(data => {
                    this.$store.dispatch(UPDATE_USER_INFO, data);
                });
            },
            // getPermissions()
            // {
            //     this.$store.dispatch(FETCH_PERSON_APP_PERMISSION_LIST, '141');
            // }
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    #nav {
        padding: 30px;

        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }

    .form-control {
        border-radius: 0.2rem !important;
        border: 1px solid #ccc !important;
    }

    .form-control:focus {
        border-color: #66afe9 !important;
    }

    #loginContainer {
        background-image: url("assets/login-background.jpg");
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
    }
</style>
